/* eslint-disable import/namespace */
//import flag from "../../assets/images/flag-1.png";
//import avatar from "../../assets/images/avatar-icon-1.jpg";
import logo from "../../assets/images/logo.png";
import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { toggleSideNav } from "../../Utils/utils/CommanFnc";
import { useSelector, useDispatch } from "react-redux";
import { setModuleId } from "../../slices/InitialDataSlice";
export function SideNav() {
  const dispatch = useDispatch() 
  const permission = useSelector((state) => state.auth.authData?.user?.permission);
  const location = useLocation()
  const [sideMenuOpen, setSideMenuOpen] = useState(false)
  useEffect( () =>{
    let menuCls = localStorage.getItem("GstartSideMenuOpen");
    if(menuCls === "true"){
      setSideMenuOpen(true)
    }
  },[])

  const activeModule = (moduleId) => {
      console.log(moduleId)
      dispatch(setModuleId({moduleId}));
  }

  // const toggleSubMenu = function (event, mainMenu) {
  //   let subMenuNew = Object.assign({}, subMenu);
  //   const menuAttr = {
  //     mainClass : "active",
  //     ariaExpanded: true,
  //     mainHrefCls: "active",
  //     childClass: "active"
  //   }
  //   //subMenuNew[mainMenu] = 
  //   subMenuNew[mainMenu] = subMenuNew?.[mainMenu]?.mainClass !== "active"? menuAttr:{};
  //   setSubmenu(subMenuNew);
  // };
   return (
    <React.Fragment>
      <div
        className={`side-nav side-menu-fixed navbar-shadow expanded collapse ${sideMenuOpen? "sidenav-less":""} `}
        id="sidenav"
        color="blue"
      >
        <div className="side-nav-header expanded">
          <ul className="nav navbar flex-row">
            <li className="nav-item mx-auto align-center col-sm-10">
              <Link to="#" className="navbar-brand ml-4">
                <img src={logo} alt="logo" />
              </Link>
            </li>
            <li className="nav-item nav-toggle mx-auto">
              <Link
                onClick={ () => toggleSideNav() }
                to="#"
                className="toggler d-xl-block"
              >
                <i className="fa fa-bars" aria-hidden="true"></i>
              </Link>
              {/* <Link
                to="javascript:void(0);"
                className="toggler d-xl-none close-panel"
              >
                <i className="fas fa-times" />
              </Link> */}
            </li>
          </ul>
        </div>

        <ul className="main-list">
          <ul className="main-list-inner pt-0 mt-0">
            <li className="item-head">
              <span>Modules</span>
            </li>
            <li className="nav-item">
              <Link to={`/dashboard`} className={`flexBox ${location.pathname === 'dashboard'?"active":''}`}>
                <i className=" fas fa-solid fa-circle" />
                <span>Dashboard</span>
              </Link>
            </li>
            {
              permission?.map( (item, index) =>{
                  return (
                    <div key={index}>
                      {
                          <li className="nav-item">
                            <Link onClick={ (e) => activeModule(item._id) } to={`/${item.modulePath}`} className={`flexBox ${location.pathname === item.modulePath?"active":''}`}>
                              <i className=" fas fa-solid fa-circle" />
                              <span>{item.moduleName}</span>
                            </Link>
                          </li>
                      }
                      

                    </div>
                  )
              } )
            }
           {/*
            <li className={`nav-item sub-menu ${subMenu?.games?.mainClass}`} data-toggle="collapse" href="#collapseExample" role="button"
                                aria-expanded={`${subMenu?.games?.ariaExpanded}`} aria-controls="collapseExample">
                <span onClick={(e) => toggleSubMenu(e,"games") } replace={false} className={`flexBox ${subMenu?.games?.mainHrefCls}`}>
                  <i className=" fas fa-gamepad" />
                  <span>Games</span>
                </span>  
                <ul className={`menu-content collapse ${subMenu?.games?.childClass}`} id="collapseExample">
                    <li className="nav-item">
                        <Link to={"/games/single"} className={`flexBox  ${params.type === "single" && location.pathname === "/games" ?'active':''} `}>
                            <i className="fa fa-circle"></i>
                            <span className="menu-text">Single</span>
                        </Link>
                    </li>
                    <li className="nav-item">
                        <Link to={"/games/challenge"} className={`flexBox  ${params.type === "challenge" && location.pathname === "/games" ?'active':''} `}>
                            <i className="fa fa-circle"></i>
                            <span className="menu-text">Challenge</span>
                        </Link>
                    </li>
                </ul>
            </li> */}
          </ul>
        </ul>
      </div>
    </React.Fragment>

  );
}
